module.exports = __webpack_public_path__ + "static/media/map.7282b386.svg";